export default __webpack_public_path__ + "static/button_green_down-f29f62fcead7d4749cdebcc430e2aa06.png";